
import {
  useEffect,
  useState,
} from "react";

import {
  ACCESS_POLICY_EVENT,
} from "./permissions";


export default function useAccessPolicyVersion() {

  const [version, setVersion] =
    useState(0);


  useEffect(() => {

    const refresh = () => {

      setVersion(
        (current) =>
          current + 1
      );
    };


    window.addEventListener(
      ACCESS_POLICY_EVENT,
      refresh
    );


    return () => {

      window.removeEventListener(
        ACCESS_POLICY_EVENT,
        refresh
      );
    };

  }, []);


  return version;
}
